import { render, staticRenderFns } from "./RecordsIpv4.vue?vue&type=template&id=19acacf2&scoped=true&"
import script from "./RecordsIpv4.vue?vue&type=script&lang=js&"
export * from "./RecordsIpv4.vue?vue&type=script&lang=js&"
import style0 from "./RecordsIpv4.vue?vue&type=style&index=0&id=19acacf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19acacf2",
  null
  
)

export default component.exports